module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAABHNCSVQICAgIfAhkiAAAAKpJREFUKJGVkusRAyEIhL88+jpSmUklSSd6naQT8yOaQ07IHDOOgLsLg5zwTYBFxStQLOjiEJ/tfqv8SwmFloHkvKXgbQqQSS63PABnIyCqRU0URSqMsxmsOr60ytbfdVBMpd7BwvYD2t+ZrVTbyQozzGAmUANAMmKHQP/EQ5FOdncgM05di8zIPZYOjDbPG9qvy2h1PZPOuwK3JlD5/m8x4JVt80Tdd+DxATXgNrrqfHpUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliLocation.png
// module id = iqJi
// module chunks = 1